import React from 'react';
import {
  Home,
  Award,
  MountainSnow,
  Rocket,
  PawPrint,
  Sparkles,
  Volleyball,
  Heart,
  LucideIcon,
} from 'lucide-react';

export type AlbumCategory =
  | 'welcome-home'
  | 'training'
  | 'adventures'
  | 'breakthroughs'
  | 'moments'
  | 'favorites'
  | 'games'
  | 'health';

const albumIconMap: Record<AlbumCategory, LucideIcon> = {
  'welcome-home': Home,
  training: Award,
  adventures: MountainSnow,
  breakthroughs: Rocket,
  moments: PawPrint,
  favorites: Sparkles,
  games: Volleyball,
  health: Heart,
};

export function useAlbumIcon(category: AlbumCategory) {
  const IconComponent = albumIconMap[category] || albumIconMap['welcome-home'];

  return {
    icon: (
      <IconComponent
        size={24}
        strokeWidth={2}
      />
    ),
  };
}
